class IngredientDropdown extends HTMLElement {
  constructor() {
    super();

    this.header = this.querySelector('.ingredient__name');
    this.content = this.querySelector('.ingredient_description');

    this.header.addEventListener('click', () => this.toggleDropdown());
  }

  toggleDropdown() {
    if (window.innerWidth <= 749) {
      this.classList.toggle('active');
    }
  }
}

customElements.define('ingredient-dropdown', IngredientDropdown);
